export enum Sida {
    HÖGER_SIDA = "HÖGER_SIDA",
    VÄNSTER_SIDA = "VÄNSTER_SIDA",
    BILATERALT = "BILATERALT",
    EJ_AKTUELLT = "EJ_AKTUELLT",
}

export enum Avvikelser {
    UTEBLIVEN = "Utebliven",
    SEN_AVBOKNING = "Sen avbokning",
}

export const SidaLabels: Record<Sida, string> = {
    [Sida.HÖGER_SIDA]: "Höger sida",
    [Sida.VÄNSTER_SIDA]: "Vänster sida",
    [Sida.BILATERALT]: "Bilateralt",
    [Sida.EJ_AKTUELLT]: "Ej aktuellt",
};

export enum VardplatsStatus {
    BESTALLD = "Beställd",
    BOKAD = "Bokad",
    INSKRIVEN = "Inskriven",
    UTSKRIVEN = "Utskriven",
    STRUKEN = "Struken",
}

export enum VardplatsAction {
    OPEN_VARDPLATSBESTALLNING = "openVardplatsbestallning",
    HANTERA_VARDPLATS = "hanteraVardplats",
    STRYK_VARDPLATS = "strykVardplats",
    SKRIV_IN_PATIENT = "skrivInPatient",
    SKRIV_UT_PATIENT = "skrivUtPatient",
}

export enum HanteraVardplatsOption {
    SKRIV_IN = "skrivIn",
    SKRIV_UT = "skrivUt",
    DEFAULT = "",
}

export type Vardplatsbestallning = {
    id: string;
    patient: any;
    externt_id: string;
    operationsdatum: any;
    operationstid: any;
    installelsedatum: any;
    installelsetid: any;
    antal_varddygn: number;
    vardgivare: any;
    operator: any;
    typoperation: string;
    huvuddiagnos: any;
    huvudoperationskod: any;
    bioperationskoder: Array<any>;
    info_till_vardavdelningen: string;
    sida: Sida;
    status: VardplatsStatus;
    slutenvardsbesok: string;
    created_at: unknown;
    created_by: unknown;
    created_by_display: any;
    vardform: any;
};

export type VardplatsbestallningStryk = {
    id: string;
    status: VardplatsStatus;
    strykningsorsak: string;
    patient_utebliven: boolean;
    sen_avbokning: boolean;
};

export type Slutenvardsbesok = {
    id: string;
    vardplatsbestallning: Vardplatsbestallning;
    operationsanmalan: any;
    anhorigbesok: Anhorigbesok;
    patient: any;
    indatum: any;
    intid: any;
    utdatum: any;
    uttid: any;
    inskriven_tidpunkt: Date;
    utskriven_tidpunkt: Date;
    sang: any;
    status: VardplatsStatus;
    strykningstidpunkt: Date;
    strykningsorsak: Date;
    patient_utebliven: boolean;
    avvikelser: string;
    created_at: Date;
    updated_at: Date;
    created_by: any;
    updated_by: any;
};

export type Anhorigbesok = {
    id: string;
    slutenvardsbesok: string; // id
    namn: string;
    sang: any;
    // properties från slutenvårdsbesök
    patient_personId_formatted: string;
    patient_namn: string;
    patient_namn_reverse: string;
    indatum: any;
    intid: any;
    utdatum: any;
    uttid: any;
    inskriven_tidpunkt: Date;
    utskriven_tidpunkt: Date;
    status: VardplatsStatus;
    aktiv: boolean;
};

export type StructuredAvdelning = {
    alias: string;
    id: string;
    salar: {
        id: string;
        namn: string;
        sangar: {
            id: string;
            name: string;
        }[];
    }[];
};
